import { setBeamState } from "@reducers/options/beam/actions";
import { setPanelDPL, setPanelDPP, setPanelState } from "@reducers/options/panel/actions";
import { setScrewState } from "@reducers/options/screw/actions";
import { 
  setDesignation, 
  setManufacturer, 
  setPredefinedBasePlate, 
  setProfileMaterial, 
  setProfileFamily,
  setProfileSize, 
  setPredefinedBasePlateImg
} from "@reducers/selectors/application/actions";
import { setBasePlateOptions } from "@reducers/selectors/dimension/actions";
import { mergeDeep } from "@services/helper.service";
import applicationTabService from "@services/requests/application-tab.service";
import { getProfileShape, getProfileSizes } from "../profile/actions";
import { initState as initDimensionState } from "@reducers/selectors/dimension";

export const SET_PREDEFINED_BP_SPINNER = 'SET_PREDEFINED_BP_SPINNER';
export const SET_MANUFACTURERS = 'SET_MANUFACTURERS';
export const SET_DESIGNATIONS = 'SET_DESIGNATIONS';
export const CLEAR_DESIGNATIONS = 'CLEAR_DESIGNATIONS';

export function setPredefinedBPSpinner(isSpinning) {
  return (dispatch) => {
    dispatch({ type: SET_PREDEFINED_BP_SPINNER, value: isSpinning });
  };
}
export function setManufacturers(value) {
  return (dispatch) => {
    dispatch({ type: SET_MANUFACTURERS, value });
  };
}
export function setDesignations(manufacturer, designations) {
  return (dispatch) => {
    dispatch({ type: SET_DESIGNATIONS, manufacturer, designations });
  };
}
export function clearDesignations() {
  return (dispatch) => {
    dispatch({ type: CLEAR_DESIGNATIONS });
    dispatch(setDesignation(""));
  };
}

export function getSBPredefinedBPs() {
  return (dispatch, getState) => {
    dispatch(setPredefinedBPSpinner(true));
    var plateData = {
      "application": getState().main.appType,
      "type": getState().selectors.application[getState().main.appType].selectedType.id,
      "subtype": getState().selectors.application[getState().main.appType].selectedSubtype.id,
      "basePlate": getState().selectors.application[getState().main.appType].selectedPlate
    };

    return applicationTabService.getPredefinedBasePlates(plateData)
      .then((basePlates) => {
        // clear data
        dispatch(setManufacturer(''));
        dispatch(clearDesignations());
        dispatch(setPredefinedBasePlateImg(''));
        if (basePlates && basePlates.length) {
          var manufacturers = basePlates
            .map((bp) => { return bp.Manufacturer; })
            .filter((val, index, self) => { return self.indexOf(val) === index; }); // unique manufacturers
          dispatch(setManufacturers(manufacturers));
          // dispatch(setManufacturer(''));
          // dispatch(setManufacturer(manufacturers[0]));
        
          // dispatch(clearDesignations());
          manufacturers.forEach((m) => {
            var designations = basePlates
              .filter((val, index, self) => { return val.Manufacturer === m && self.indexOf(val) === index; }) // unique designations
              .map((bp) => { return { "id": bp.ID, "designation": bp.Designation };});
            dispatch(setDesignations(m, designations));
            // if (m === manufacturers[0])
            //   dispatch(setDesignation(designations[0].id));
          });
        } else {
          dispatch(setManufacturers([]));
        }
        
        dispatch(setPredefinedBPSpinner(false));
      }
    );
  };
}

export function getSBPredefinedBP() {
  return (dispatch, getState) => {
    dispatch(setPredefinedBPSpinner(true));
    var basePlateId = getState().selectors.application[getState().main.appType].predefinedBasePlate && 
      getState().selectors.application[getState().main.appType].predefinedBasePlate.selectedDesignationId;

    return applicationTabService.getPredefinedBasePlate(basePlateId)
      .then((data) => {
        if (data && data.profile && data.basePlate && data.axisPosition) {
          dispatch(setBasePlateOptions({
            lx: data.basePlate.lx,
            ly: data.basePlate.ly,
            dpp: data.basePlate.dpp,
            dpl: data.basePlate.dpl,
            lyh: data.basePlate.lyh,
      
            tfix: data.basePlate.tfix,
      
            spacing: {
              s1: data.basePlate.spacing.s1,
              s2: data.basePlate.spacing.s2,
              dy: data.basePlate.spacing.dy,
              d: data.basePlate.spacing.d,
            },
      
            // edgeDistance: {
            //   c1x: data.basePlate.edgeDistance.c1x,
            //   c2x: data.basePlate.edgeDistance.c2x,
            //   c1y: data.basePlate.edgeDistance.c1y,
            // }
          }));
          dispatch(setPanelState(mergeDeep({}, getState().options.panel, {
            width: data.basePlate.lx,
            height: data.basePlate.ly,
            // dpp: {
            //   value: data.basePlate.dpp
            // },
            // dpl: {
            //   value: data.basePlate.dpl
            // },
            lyh: {
              value: data.basePlate.lyh
            },
            depth: data.basePlate.tfix,
            dy: {
              value: data.basePlate.spacing.dy,
            },
          })));
          dispatch(setScrewState(mergeDeep({}, getState().options.screw, {
            padding: {
              s1: data.basePlate.spacing.s1,
              s2: data.basePlate.spacing.s2,
              diameter: data.basePlate.spacing.d
            },
          })));
          // dispatch(setGroundState(mergeDeep({}, getState().options.ground, {
          //   padding: {
          //     C1x: data.basePlate.edgeDistance.c1x || null, // Null = ∞ char in UI
          //     C2x: data.basePlate.edgeDistance.c2x || null,
          //     C1y: data.basePlate.edgeDistance.c1y || null,
          //   },
          // })));

          dispatch(setBeamState(mergeDeep({}, getState().options.beam, {
            shift: {
              x: data.axisPosition.ex,
              y: data.axisPosition.ey
            }
          })));
          
          dispatch(setProfileMaterial(data.profile.material));
          dispatch(setProfileFamily(data.profile.family));
          dispatch(getProfileSizes(data.profile.family,
            (profileSizes) => {
              if (profileSizes && profileSizes.length) {
                let size = profileSizes.find((size) => {
                  return size.InternalName === data.profile.size;
                });
                if (size === null || size === undefined)
                  size = profileSizes[0];
                dispatch(setProfileSize(size.InternalName));
                dispatch(getProfileShape(data.profile.family, size.InternalName, true));
              }
            })
          );

          // Base plate dimensions which must be reset to default to make sure the plate is on concrete:
          var appType = getState().main.appType;
          dispatch(setPanelDPP({
            value: initDimensionState[appType].basePlate.dpp
          }));
          dispatch(setPanelDPL({
            value: initDimensionState[appType].basePlate.dpl
          }));
        } else {
          dispatch(setPredefinedBasePlate(false));
          dispatch(setManufacturer(''));
          dispatch(setDesignation(''));
          dispatch(setPredefinedBasePlateImg(''));
        }
        
        dispatch(setPredefinedBPSpinner(false));
      }
    );
  };
}

export function getSBPredefinedBPImage() {
  return (dispatch, getState) => {
    var basePlateId = getState().selectors.application[getState().main.appType].predefinedBasePlate && 
      getState().selectors.application[getState().main.appType].predefinedBasePlate.selectedDesignationId;

    return applicationTabService.getPredefinedBasePlateImage(basePlateId)
      .then((imagePath) => {
        dispatch(setPredefinedBasePlateImg(imagePath));
    });
  };
}



// WEBPACK FOOTER //
// ./src/reducers/web-services/application/actions.js